import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ScopesActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить роут (ID: ${_ctx.state.id})?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      (!_ctx.isBind)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 0,
            class: "w-full",
            value: _ctx.state.path,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.path) = $event)),
            "is-invalid": _ctx.state_form$.path.$error,
            "validation-errors": _ctx.state_form$.path.$errors,
            placeholder: "Путь"
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      (!_ctx.isBind)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 1,
            class: "w-full mt-3",
            value: _ctx.state.method,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.method) = $event)),
            "is-invalid": _ctx.state_form$.method.$error,
            "validation-errors": _ctx.state_form$.method.$errors,
            placeholder: "Метод",
            options: _ctx.METHOD_OPTIONS,
            searchable: false,
            "select-by": "name"
          }, null, 8, ["value", "is-invalid", "validation-errors", "options"]))
        : _createCommentVNode("", true),
      (!_ctx.isBind)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 2,
            class: "mt-3",
            value: _ctx.state.service_id,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.service_id) = $event)),
            placeholder: "Микросервисы",
            "is-invalid": _ctx.state_form$.service_id.$error,
            "validation-errors": _ctx.state_form$.service_id.$errors,
            loading: _ctx.data_state.microservices.is_loading,
            options: _ctx.data_state.microservices.list,
            failed: _ctx.data_state.microservices.is_failed,
            "error-text": "При получении списка микросервисов произошла ошибка",
            "infinite-scroll": "",
            "select-by": "id",
            onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMicroservices(_ctx.data_state.microservices.pagination.current_page))),
            onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreMicroservices(_ctx.data_state.microservices.pagination.current_page + 1)))
          }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"]))
        : (_openBlock(), _createBlock(_component_the_select, {
            key: 3,
            class: "mt-3",
            value: _ctx.state.service_id,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.service_id) = $event)),
            placeholder: "Скоупы",
            "is-invalid": _ctx.state_form$.service_id.$error,
            "validation-errors": _ctx.state_form$.service_id.$errors,
            loading: _ctx.data_state.scopes.is_loading,
            options: _ctx.data_state.scopes.list,
            failed: _ctx.data_state.scopes.is_failed,
            "error-text": "При получении списка скоупов произошла ошибка",
            "infinite-scroll": "",
            "select-by": "id",
            label: "scope",
            onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadScopes(_ctx.data_state.scopes.pagination.current_page))),
            onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreScopes(_ctx.data_state.scopes.pagination.current_page + 1)))
          }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"])),
      (!_ctx.isBind)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 4,
            class: "w-full mt-3",
            value: _ctx.state.summary,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.summary) = $event)),
            "is-invalid": _ctx.state_form$.summary.$error,
            "validation-errors": _ctx.state_form$.summary.$errors,
            placeholder: "Описание"
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      (!_ctx.isBind)
        ? (_openBlock(), _createBlock(_component_checkbox, {
            key: 5,
            class: "mt-3",
            value: _ctx.state.status,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.status) = $event)),
            label: "Активен"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}